export const name = "repaymentAmount";
export const nameLoc = "minRepaymentAmount";